import React from 'react';
import { khachHangSearchColumns, QUERY_KEYS, tinhChatThueSearchColumns } from '@/constants';
import { FormField, SearchField } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { KhachHang, TinhChatThue } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface CustomerInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export default function CustomerInfoTab({ formMode, formState: { state, actions } }: CustomerInfoTabProps) {
  const maTCOptions = [
    {
      label:
        '1. Hàng hóa, dịch vụ dùng riêng cho SXKD chịu thuế GTGT và sử dụng cho các hoạt động cung cấp hàng hoá, dịch vụ không kê khai, nộp thuế GTGT đủ điều kiện',
      value: '1'
    },
    { label: '2. Hàng hóa, dịch vụ dùng chung cho SXKD chịu thuế GTGT và không chịu thuế GTGT', value: '2' },
    { label: '3. Hàng hóa, dịch vụ dùng cho dự án đầu tư đủ điều kiện khấu trừ thuế', value: '3' },
    { label: '4. Hàng hóa, dịch vụ không đủ điều kiện khấu trừ', value: '4' },
    { label: '5. Hàng hóa, dịch vụ không phải tổng hợp trên tờ khai 01/GTGT', value: '5' }
  ];
  return (
    <div className='p-4'>
      <div className='flex flex-col gap-3'>
        {/* Nhóm sản phẩm */}
        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Nhóm sản phẩm</Label>
          <FormField name='ten_vt_thue' type='text' disabled={formMode === 'view'} />
        </div>

        {/* Cục thuế */}
        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Cục thuế</Label>
          <SearchField<KhachHang>
            type='text'
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
            searchColumns={khachHangSearchColumns}
            value={state.coQuanThue?.customer_code || ''}
            relatedFieldValue={state.coQuanThue?.customer_name || ''}
            onRowSelection={actions.setCoQuanThue}
            disabled={formMode === 'view'}
            dialogTitle='Danh mục cục thuế'
            className='w-full'
          />
        </div>

        {/* Mẫu báo cáo */}
        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Mẫu báo cáo</Label>
          <FormField
            name='ma_mau_bc'
            type='select'
            className='min-w-40'
            options={[
              { value: '3', label: '3. Hóa đơn giá trị gia tăng' },
              { value: '4', label: '4. Hàng hóa, dịch vụ mua vào không có hóa đơn' },
              { value: '5', label: '5. Hóa đơn giá trị gia tăng' }
            ]}
            disabled={formMode === 'view'}
          />
        </div>

        {/* Mã tính chất */}
        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Mã tính chất</Label>
          <SearchField<TinhChatThue>
            type='text'
            columnDisplay='ma_tc_thue'
            displayRelatedField='ten_tc_thue'
            searchEndpoint={`/${QUERY_KEYS.TINH_CHAT_THUE}`}
            searchColumns={tinhChatThueSearchColumns}
            value={state.tinhChatThue?.ten_tc_thue || ''}
            relatedFieldValue={state.tinhChatThue?.ten_tc_thue || ''}
            onRowSelection={actions.setTinhChatThue}
            disabled={formMode === 'view'}
            dialogTitle='Danh mục tính chất thuế'
            className='w-full'
          />
        </div>

        {/* Kê thuế đầu vào */}
        <div className='flex items-center'>
          <Label className='min-w-40 text-sm font-medium'>Kê thuế đầu vào</Label>
          <FormField name='invat_yn' type='checkbox' disabled={formMode === 'view'} />
        </div>
      </div>
    </div>
  );
}
